import SimpleSchema from 'simpl-schema';

import store from '../../config/configureStore';
import { getCategoryOfCode } from 'utils/functions';

export const partiesSchema = () => {
  SimpleSchema.setDefaultMessages({
    messages: {
      en: store?.store.getState().incident.ibrsValidationRules?.party || {},
    },
  });

  return new SimpleSchema({
    age: {
      type: SimpleSchema.Integer,
      label: 'Person Age',
      optional: true,
      custom() {
        const ibrsVersion = store.store.getState().user?.ibrsVersion;
        const codeVictimCategory = store.store.getState().dictionary.codeVictimCategory;

        if (this.obj.victims.length) {
          if (this.value && (this.value < 0 || this.value > 99)) {
            return 'NIBRS-2019.2-124';
          }

          //NIBRS-2019.2-126: Person Age
          if (this.obj.personForm.values?.ageRangeIncrement) {
            let value = parseInt(this.obj.personForm.values?.age);
            if (value === 0 || value < 0) {
              return 'NIBRS-2019.2-126';
            }
          }

          for (let victimOffense of this.obj.victimOffenses) {
            if (victimOffense) {
              if (
                victimOffense.offenseDetails?.values?.statuteDetails?.FBICode === '36B' &&
                this.value > 18
              ) {
                return 'NIBRS-2019.2-130';
              }

              //TEXAS-2023.1-03
              if (ibrsVersion === 'TEXAS') {
                if (
                  victimOffense.offenseDetails?.values?.statuteDetails?.FBICode === '36A' &&
                  this.value < 17
                ) {
                  return 'TEXAS-2023.1-03';
                }
              }
            }
          }

          for (let victim of this.obj.victims) {
            const codeVictimCategoryType = getCategoryOfCode(
              codeVictimCategory,
              victim.incVictimDetails.values?.category
            );
            if (codeVictimCategoryType === 'l') {
              if (this.value < 17 || this.value > 98) {
                return 'NIBRS-2019.2-128';
              }
            }

            if (!['i', 'l'].includes(codeVictimCategoryType) && this.value) {
              return 'NIBRS-2019.2-129 Age';
            }

            if (['i', 'l'].includes(codeVictimCategoryType)) {
              if (this.obj.personForm.values?.isUnknownParty !== true) {
                if (!this.value || this.value === 0) {
                  return 'NIBRS-2019.2-123(Age)';
                }
              }
            }
          }
        } else if (this.obj.offenders.length) {
          // NIBRS-2019.2-158: Property Drug Quantity
          for (let offender of this.obj.offenders) {
            if (offender?.incSubjectDetails?.values?.unknown) {
              if (this.value) {
                return 'NIBRS-2019.2-158 Age';
              }
            }
          }

          for (let offenderOffense of this.obj.offenderOffenses) {
            if (offenderOffense) {
              if (
                offenderOffense?.offenseDetails?.values?.statuteDetails?.FBICode === '09C' &&
                (!this.value || this.value === 0)
              ) {
                return 'NIBRS-2019.2-157(Age)';
              }

              // TEXAS-2023.1-05
              if (ibrsVersion === 'TEXAS') {
                if (
                  offenderOffense.offenseDetails?.values?.statuteDetails?.FBICode === '36A' &&
                  this.value < 17
                ) {
                  return 'TEXAS-2023.1-05';
                }
              }
            }
          }

          //NIBRS-2019.2-126: Person Age
          if (this.obj.personForm.values?.ageRangeIncrement) {
            let value = parseInt(this.obj.personForm.values?.age);
            if (value === 0 || value < 0) {
              return 'NIBRS-2019.2-126';
            }
          }

          //NIBRS-2019.2-124: Person Age
          if (this.value && (this.value < 0 || this.value > 99)) {
            return 'NIBRS-2019.2-124';
          }
        }
      },
    },

    sex: {
      type: String,
      label: 'Person Sex',
      optional: true,
      custom() {
        // in case of society, we don't need to validate
        if (this.obj.personForm.values?.isSociety) return;

        const codeVictimCategory = store.store.getState().dictionary.codeVictimCategory;
        const codeSex = store.store.getState().dictionary.codeSex;
        if (this.obj.victims.length) {
          const sexCategory = getCategoryOfCode(codeSex, this.value);

          for (let victimOffense of this.obj.victimOffenses) {
            if (victimOffense) {
              if (
                victimOffense.offenseDetails.values.statuteDetails?.FBICode === '11A' ||
                victimOffense.offenseDetails.values.statuteDetails?.FBICode === '36B'
              ) {
                if (!sexCategory === 'm' || !sexCategory === 'f') {
                  return 'NIBRS-2019.2-131';
                }
              }
            }
          }

          for (let victim of this.obj.victims) {
            const codeVictimCategoryType = getCategoryOfCode(
              codeVictimCategory,
              victim.incVictimDetails.values?.category
            );

            if (
              !['i', 'l', 's'].includes(codeVictimCategoryType) &&
              this.value &&
              this.value.length !== 0
            ) {
              return 'NIBRS-2019.2-129 Sex';
            }

            if (['i', 'l'].includes(codeVictimCategoryType)) {
              if (!this.value || this.value.length === 0) {
                return 'NIBRS-2019.2-123(Sex)';
              }
            }
          }
        }

        if (this.obj.offenders.length) {
          for (let offenderOffense of this.obj.offenderOffenses) {
            if (offenderOffense) {
              if (
                offenderOffense?.offenseDetails?.values?.statuteDetails?.FBICode === '09C' &&
                !this.value
              ) {
                return 'NIBRS-2019.2-157(Sex)';
              }
            }
          }

          for (let offender of this.obj.offenders) {
            if (offender?.incSubjectDetails?.values?.unknown) {
              if (this.value) {
                return 'NIBRS-2019.2-158 Sex';
              }
            }
          }
        }
      },
    },

    race: {
      type: String,
      label: 'Person Race',
      optional: true,
      custom() {
        // in case of society, we don't need to validate
        if (this.obj.personForm.values?.isSociety) return;

        const ibrsVersion = store.store.getState().user?.ibrsVersion;
        const codeVictimCategory = store.store.getState().dictionary.codeVictimCategory;
        if (this.obj.victims.length) {
          for (let victim of this.obj.victims) {
            const codeVictimCategoryType = getCategoryOfCode(
              codeVictimCategory,
              victim.incVictimDetails.values?.category
            );

            if (
              !['i', 'l', 's'].includes(codeVictimCategoryType) &&
              this.value &&
              this.value.length !== 0
            ) {
              return 'NIBRS-2019.2-129 Race';
            }

            if (['i', 'l'].includes(codeVictimCategoryType)) {
              if (!this.value || this.value.length === 0) {
                return 'NIBRS-2019.2-123(Race)';
              }
            }
          }
        } else if (this.obj.offenders.length) {
          for (let offenderOffense of this.obj.offenderOffenses) {
            if (offenderOffense) {
              if (
                offenderOffense?.offenseDetails?.values?.statuteDetails?.FBICode === '09C' &&
                !this.value
              ) {
                return 'NIBRS-2019.2-157(Race)';
              }
            }
          }

          for (let offender of this.obj.offenders) {
            if (offender?.incSubjectDetails?.values?.unknown) {
              if (this.value) {
                return 'NIBRS-2019.2-158 Race';
              }
            }
          }
        }
        if (ibrsVersion === 'TEXAS') {
          if (
            !['A', 'B', 'W', 'I', 'P', 'U'].includes(this.obj.personForm.values?.race) &&
            this.obj.personForm.values?.race
          ) {
            return 'TEXAS-2023.1-07';
          }
        }
      },
    },

    ethnicity: {
      type: String,
      label: 'Person Ethnicity',
      optional: true,
      custom() {
        // in case of society, we don't need to validate
        if (this.obj.personForm.values?.isSociety) return;

        const codeVictimCategory = store.store.getState().dictionary.codeVictimCategory;
        if (this.obj.victims.length) {
          for (let victim of this.obj.victims) {
            const codeVictimCategoryType = getCategoryOfCode(
              codeVictimCategory,
              victim.incVictimDetails.values?.category
            );

            if (
              !['i', 'l', 's'].includes(codeVictimCategoryType) &&
              this.value &&
              this.value.length !== 0
            ) {
              return 'NIBRS-2019.2-129 Ethnicity';
            }
          }
        }
      },
    },

    arresteeAge: {
      type: SimpleSchema.Integer,
      label: 'NIBRS-2019.2-176: Arrestee Age',
      optional: true,
      custom() {
        if (!this.value || this.value === 0) {
          return 'NIBRS-2019.2-176';
        }

        if (this.value && (this.value < 0 || this.value > 99)) {
          return 'NIBRS-2019.2-124';
        }
      },
    },

    arresteeRace: {
      type: String,
      label: 'NIBRS-2019.2-180: Arrestee Race',
      optional: true,
      custom() {
        if (!this.value) {
          return 'NIBRS-2019.2-180';
        }
      },
    },

    arresteeSex: {
      type: String,
      label: 'NIBRS-2019.2-178: Arrestee Sex | NIBRS-2019.2-179: Arrestee Sex',
      optional: true,
      custom() {
        const codeSex = store.store.getState().dictionary.codeSex;
        const sexCategory = getCategoryOfCode(codeSex, this.value);

        if (!this.value) {
          return 'NIBRS-2019.2-178';
        } else {
          if (sexCategory === 'u') {
            return 'NIBRS-2019.2-179';
          }
        }
      },
    },
  });
};
